// src/config/page.types.ts

export enum PageType {
	ResultsOverview = "RESULTS_OVERVIEW",
	ResultsTransport = "RESULTS_TRANSPORT",
	ResultsTransportGreenRouter = "RESULTS_TRANSPORT_GREENROUTER",
	ResultsTransportGreenRouterEntities = "RESULTS_TRANSPORT_GREENROUTER_ENTITIES",
	ResultsTransportGreenRouterDetail = "RESULTS_TRANSPORT_GREENROUTER_DETAIL",
	ResultsTransportGreenRouterEntityDetail = "RESULTS_TRANSPORT_GREENROUTER_ENTITY_DETAIL",
	ResultsTransportThirdParty = "RESULTS_TRANSPORT_THIRD_PARTY",
	ResultsTransportThirdPartyDetail = "RESULTS_TRANSPORT_THIRD_PARTY_DETAIL",

	DataInsightsDashboard = "DATA_INSIGHTS_DASHBOARD",
	DataInsightsDashboardDetail = "DATA_INSIGHTS_DASHBOARD_DETAIL",
	DataInsightsHotspots = "DATA_INSIGHTS_HOTSPOTS",
	DataInsightsRootCause = "DATA_INSIGHTS_ROOT_CAUSE",
	DataInsightsRootCauseResults = "DATA_INSIGHTS_ROOT_CAUSE_RESULTS",

	MasterDataOperationalUnits = "MASTER_DATA_OPERATIONAL_UNITS",
	MasterDataOperationalUnitsAddUnit = "MASTER_DATA_OPERATIONAL_UNITS_ADD_UNIT",
	MasterDataOperationalUnitsDetail = "MASTER_DATA_OPERATIONAL_UNITS_DETAIL",
	MasterDataAssumptions = "MASTER_DATA_ASSUMPTIONS",
	MasterDataFleetsVehicles = "MASTER_DATA_FLEETS_VEHICLES",
	MasterDataNetworksRoutes = "MASTER_DATA_NETWORKS_ROUTES",
	MasterDataConversionTables = "MASTER_DATA_CONVERSION_TABLES",

	ResultsOperationalUnits = "RESULTS_OPERATIONAL_UNITS",
	ResultsOperationalUnitsGreenRouter = "RESULTS_OPERATIONAL_UNITS_GREENROUTER",
	ResultsOperationalUnitsGreenRouterDetail = "RESULTS_OPERATIONAL_UNITS_GREENROUTER_DETAIL",
	ResultsOperationalUnitsThirdParty = "RESULTS_OPERATIONAL_UNITS_THIRD_PARTY",
	ResultsOperationalUnitsThirdPartyDetail = "RESULTS_OPERATIONAL_UNITS_THIRD_PARTY_DETAIL",

	WhatIfSimulations = "WHAT_IF_SIMULATIONS",
	WhatIfBudgeting = "WHAT_IF_BUDGETING",
	WhatIfCarbonSnap = "WHAT_IF_CARBON_SNAP",
	WhatIfCarbonSnapResults = "WHAT_IF_CARBON_SNAP_RESULTS",

	DataIOMonitor = "DATA_IO_MONITOR",
	DataIOImport = "DATA_IO_IMPORT",
	DataIOAutomatedProcesses = "DATA_IO_AUTOMATED_PROCESSES",
	DataIODataExport = "DATA_IO_DATA_EXPORT",

	KnowHowUserManuals = "KNOW_HOW_USER_MANUALS",
	KnowHowKnowledgeBase = "KNOW_HOW_KNOWLEDGE_BASE",
	KnowHowApiDocumentation = "KNOW_HOW_API_DOCUMENTATION",

	PlatformSettingsDataDomains = "PLATFORM_SETTINGS_DATA_DOMAINS",
	PlatformSettingsAdmin = "PLATFORM_SETTINGS_ADMIN",
	PlatformSettingsApi = "PLATFORM_SETTINGS_API",

	Account = "ACCOUNT",
}
